import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CartSizeSelector = ({ item, updateCartItemSize }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const sizeData = item.availableSizes || item.sizes;

  if (!sizeData?.options) {
    if (!item.selectedSize) return null;
    return <span className="text-[#1a1a1a] font-bold">{item.selectedSize} {item.sizeUnit || ''}</span>;
  }

  return (
    <div className="relative inline-block cart-size-selector-wrapper" ref={dropdownRef}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        aria-expanded={isOpen}
        className={`flex items-center gap-2 px-3 py-1.5 backdrop-blur-md rounded-xl text-xs font-bold transition-all shadow-sm active:scale-95 ${
          !item.selectedSize 
            ? 'bg-red-50/80 border-2 border-red-400 text-red-600 animate-pulse hover:bg-red-50' 
            : 'bg-white/60 border border-[#D4AF37]/30 text-[#1a1a1a] hover:border-[#D4AF37] hover:bg-white'
        }`}
      >
        <span>{item.selectedSize ? `${item.selectedSize} ${item.sizeUnit || ''}` : 'Ölçü Seçin!'}</span>
        <ChevronDown className={`w-3 h-3 ${!item.selectedSize ? 'text-red-500' : 'text-[#D4AF37]'} transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -8, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="absolute z-[110] mt-2 min-w-[120px] bg-white border border-[#D4AF37]/20 rounded-2xl shadow-2xl overflow-hidden left-0 origin-top-left"
          >
            <div className="max-h-48 overflow-y-auto custom-scrollbar p-1.5">
              <p className="text-[10px] text-[#8A8A8A] font-bold uppercase tracking-wider px-2 py-1 mb-1 border-b border-gray-50">Ölçü Seçin</p>
              {sizeData.options.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  disabled={!opt.inStock}
                  onClick={(e) => {
                    e.stopPropagation();
                    updateCartItemSize(item.cartKey || item.id, opt.value);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 text-[11px] rounded-lg transition-all flex items-center justify-between group ${
                    opt.value === item.selectedSize
                      ? 'bg-[#D4AF37]/10 text-[#D4AF37] font-bold'
                      : opt.inStock
                        ? 'text-[#5A5A5A] hover:bg-[#FAF9F6] hover:text-[#1a1a1a]'
                        : 'text-gray-300 cursor-not-allowed bg-gray-50/50 opacity-60'
                  }`}
                >
                  <span>{opt.value} {item.sizeUnit || ''}</span>
                  {!opt.inStock ? (
                    <span className="text-[9px] uppercase font-bold text-red-400">Tükendi</span>
                  ) : opt.value === item.selectedSize ? (
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]"></span>
                  ) : null}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CartSizeSelector;
